import React from 'react';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-gradient-to-b from-[#1F3D2B] to-[#2E5A3E] py-4 md:py-6 px-3 border-b border-gray-200" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 uppercase tracking-tight" data-id="element-126">
          💣 OFERTA ESPECIAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-stretch" data-id="element-127">
          {/* Kit Completo */}
          <a href="https://checkout.kitonline.shop/cart/47881274261742:1" className="bg-[#F5F5F5] rounded-xl p-3 flex flex-col h-full cursor-pointer transition-all duration-300 border-2 border-transparent hover:border-[#D4A843] hover:shadow-lg hover:scale-[1.02] no-underline" data-id="element-128">
            <h3 className="text-sm md:text-base font-black text-[#1F3D2B] uppercase mb-2" data-id="element-129">
              🎯 KIT COMPLETO
            </h3>
            <div className="text-center mb-2" data-id="element-130">
              <div className="text-2xl md:text-3xl font-black text-[#1F3D2B]" data-id="element-131">
                $19.990
              </div>
            </div>
            <ul className="space-y-1 mb-2" data-id="element-132">
              <li className="flex items-center gap-2 text-gray-800 text-xs md:text-sm font-bold" data-id="element-133">
                <Check className="w-4 h-4 text-[#2E5A3E] flex-shrink-0" strokeWidth={3} data-id="element-134" />
                6 tomos completos
              </li>
              <li className="flex items-center gap-2 text-gray-800 text-xs md:text-sm font-bold" data-id="element-135">
                <Check className="w-4 h-4 text-[#2E5A3E] flex-shrink-0" strokeWidth={3} data-id="element-136" />
                4 bonos de regalo
              </li>
            </ul>
            <div className="mt-auto bg-[#D4A843] hover:bg-[#E0B84E] text-white font-black text-center py-2.5 rounded-lg text-sm uppercase tracking-wide border-b-4 border-[#B8922E] glow-gold transition-colors" data-id="element-137">
              COMPRAR AHORA
            </div>
          </a>

          {/* Kit + Sistema Pro */}
          <a href="https://checkout.kitonline.shop/cart/47881309257966:1" className="bg-[#1F3D2B] rounded-xl p-3 flex flex-col h-full cursor-pointer transition-all duration-300 relative border-2 border-[#D4A843] hover:shadow-lg hover:shadow-[#D4A843]/20 hover:scale-[1.02] no-underline" data-id="element-138">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4A843] text-white font-black px-4 py-0.5 rounded-full text-[10px] tracking-widest uppercase whitespace-nowrap z-10" data-id="element-139">
              ⭐ RECOMENDADO
            </div>

            <h3 className="text-sm md:text-base font-black text-white uppercase mb-2 mt-1" data-id="element-140">
              🚀 KIT + SISTEMA PRO
            </h3>

            <div className="text-center mb-2" data-id="element-141">
              <div className="text-2xl md:text-3xl font-black text-[#D4A843]" data-id="element-142">
                $29.990
              </div>
            </div>

            <p className="text-white font-black text-xs mb-2 border-b border-gray-700 pb-1.5" data-id="element-143">
              ✔ Todo lo anterior +
            </p>

            <div className="bg-white/10 rounded-lg p-2 mb-2 border border-white/20" data-id="element-144">
              <h4 className="font-black text-[#D4A843] text-xs mb-1.5 uppercase" data-id="element-145">
                💥 SISTEMA PRO DE CLASES AGROPECUARIAS
              </h4>
              <ul className="space-y-1" data-id="element-146">
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-147">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-148" />
                  Clases listas paso a paso
                </li>
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-149">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-150" />
                  Actividades imprimibles
                </li>
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-151">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-152" />
                  Evaluaciones con respuestas
                </li>
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-153">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-154" />
                  Proyectos integradores
                </li>
              </ul>
            </div>

            <p className="text-center text-white font-black text-[10px] md:text-xs mb-2" data-id="element-155">
              👉 Para que tus clases sean profesionales
            </p>

            <div className="mt-auto bg-[#D4A843] hover:bg-[#E0B84E] text-white font-black text-center py-2.5 rounded-lg text-sm uppercase tracking-wide border-b-4 border-[#B8922E] glow-gold transition-colors" data-id="element-156">
              COMPRAR AHORA
            </div>
          </a>
        </div>
      </div>
    </section>;
}